import { TitleOfferFragment, TitleOfferLightFragment } from '@/features/buybox/graphql/fragments/Offer.fragment';
import { ModalHelper } from '@/helpers/vfm/modal-helper';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { type PlayerModalTitle } from '@/features/title-player/types';
import { WatchNowOfferFragment } from '@/pages/graphql/fragments/WatchNowOffer.fragment';
import { JWTV_PROVIDER_CONFIG } from '@/features/jwtv/config';

const jwtvSvodModal = () => import('@/features/jwtv-savod/components/JWTVSvodModal.vue');

type JwTVSvodModalProps = {
	offer: WatchNowOfferFragment | TitleOfferFragment | TitleOfferLightFragment;
	title?: PlayerModalTitle;
	additionalContexts?: SnowplowContext[];
};

export async function openJwTvSvodModal(payload: { modalProps: JwTVSvodModalProps; onClose?: () => void }) {
	await ModalHelper.openModal(
		jwtvSvodModal,
		{
			...payload.modalProps,
		},
		{},
		'',
		true,
		payload.modalProps.additionalContexts ?? [],
		() => {
			payload.onClose?.();
		}
	);
}

export function isJwtvSvodOffer(offer: TitleOfferFragment | WatchNowOfferFragment | TitleOfferLightFragment): boolean {
	const config = JWTV_PROVIDER_CONFIG.find(
		c => c.shortName === offer.package.shortName && c.monetizationTypes.includes(offer.monetizationType)
	);
	return !!config && config.type === 'SVOD';
}
